import state from './state'

const SETTIPOAVISOPROGRAMADOLIST = (state, list) => {
  state.tipoAvisoProgramadoList = list
}

const SETDATESELECTED = (state, date) => {
  state.dateSelected = date
}

const SETLISTAVISOSPROGRAMADOS = (state, list) => {
  state.avisosProgramados = list
}

const SETLISTAVISOSATIVOS = (state, list) => {
  state.avisosAtivos = list
}

const SETLISTAVISOSEXPIRADOS7DIAS = (state, list) => {
  state.avisosExpirados7Dias = list
}

const SETEVENTSELECTED = (state, event) => {
  state.eventSelected = event
}

const SETEVENTPUBLICOALVO = (state, list) => {
  state.eventPublicoAlvo = list
}

const SETAVISOS = (state, list) => {
  state.avisos = list
}

export default {
  SETTIPOAVISOPROGRAMADOLIST,
  SETDATESELECTED,
  SETLISTAVISOSPROGRAMADOS,
  SETLISTAVISOSATIVOS,
  SETLISTAVISOSEXPIRADOS7DIAS,
  SETEVENTSELECTED,
  SETEVENTPUBLICOALVO,
  SETAVISOS
}
